import React from "react";
import styles from "./CustomerServicesCard.module.css";
import { Link } from "react-router-dom";
import commonStyles from "../../Components/Shared/commonStyles.module.css";

function CustomerServicesCard(props) {
  return (
    <Link to={props.Link}>
      <div className={`${commonStyles.card} ${styles.Card}`}>
        <div className={styles.IconName}>
          <div className={styles.Icon}>{props.Icon}</div>
          <div className={styles.Name}>{props.Name}</div>
        </div>
        <div className={styles.Content}>
          <div className={styles.Text}>{props.Text}</div>
        </div>
      </div>
    </Link>
  );
}

export default CustomerServicesCard;
